import { Injectable } from '@angular/core';
import { companyBlacklistStateInitialState, CompanyBlacklistStateProps, companyBlacklistStateStore } from './company-blacklist-state.store';
import { select } from '@ngneat/elf';
import { BaseStoreRepository } from '../base-store.repository';

@Injectable({
  providedIn: 'root',
})
export class CompanyBlackListRepository extends BaseStoreRepository<CompanyBlacklistStateProps> {
  constructor() {
    super(companyBlacklistStateStore.pipe(select(state => state)), companyBlacklistStateStore, companyBlacklistStateInitialState);
  }
}
